import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EparcoursPath } from '../../constantes/menu/menu-items/eparcours-path';
import { EntreprisesPath } from '../../pages/entreprises/entreprises-path';
import { NavService } from './nav-service';
import { PARAM_TOKEN } from './navigators/navigators';

@Injectable({
  providedIn: 'root',
})
export class EntreprisesNavService extends NavService {
  constructor(router: Router) {
    super(router);
  }

  edition = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.ENTREPRISES,
    EparcoursPath.entreprises.EDITION,
    PARAM_TOKEN,
    EparcoursPath.entreprises.EDITION_GENERAL,
  );

  facturesByIdEntreprise = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.ENTREPRISES,
    EparcoursPath.entreprises.EDITION,
    PARAM_TOKEN,
    EparcoursPath.entreprises.LISTE_FACTURES,
  );

  personnesByIdEntreprise = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.ENTREPRISES,
    EparcoursPath.entreprises.EDITION,
    PARAM_TOKEN,
    EparcoursPath.entreprises.LISTE_PERSONNES,
  );

  creation = this.makeNavigator(EparcoursPath.root.ENTREPRISES, EparcoursPath.entreprises.CREATION);

  creation_personne = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.ENTREPRISES,
    EparcoursPath.entreprises.EDITION,
    PARAM_TOKEN,
    EparcoursPath.entreprises.CREATION_PERSONNE,
  );

  documentsEntreprise = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.ENTREPRISES,
    EparcoursPath.entreprises.EDITION,
    PARAM_TOKEN,
    EparcoursPath.entreprises.DOCUMENTS,
  );

  taches = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.ENTREPRISES,
    EntreprisesPath.EDITION,
    PARAM_TOKEN,
    EntreprisesPath.TACHES
  );

  inscriptions = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.ENTREPRISES,
    EntreprisesPath.EDITION,
    PARAM_TOKEN,
    EntreprisesPath.INSCRIPTION
  );

  entreprises_liees = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.ENTREPRISES,
    EntreprisesPath.EDITION,
    PARAM_TOKEN,
    EntreprisesPath.ENTREPRISES_LIEES
  );

  liste = this.makeNavigator(EparcoursPath.root.ENTREPRISES);
}
